import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8834217a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-3" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Loading Content ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_LineMenu = _resolveComponent("LineMenu")!
  const _component_RecRequest = _resolveComponent("RecRequest")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_ViewTemplate = _resolveComponent("ViewTemplate")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ViewTemplate, { title: "Recommended Donors" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("b", null, _toDisplayString(_ctx.pat.firstname) + " " + _toDisplayString(_ctx.pat.lastname) + ", " + _toDisplayString(_ctx.pat.patientid), 1)
        ]),
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm",
          value: [_ctx.pat],
          resizableColumns: "",
          autoLayout: "",
          stripedRows: "",
          showGridlines: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "ABORH",
              bodyClass: "aboCmv"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getAboRh(slotProps.data.abo, slotProps.data.rh)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "CMV",
              bodyClass: "aboCmv"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.Cmv.byCode(slotProps.data.cmv)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "a1",
              header: "A.1"
            }),
            _createVNode(_component_Column, {
              field: "a2",
              header: "A.2"
            }),
            _createVNode(_component_Column, {
              field: "b1",
              header: "B.1"
            }),
            _createVNode(_component_Column, {
              field: "b2",
              header: "B.2"
            }),
            _createVNode(_component_Column, {
              field: "c1",
              header: "C.1"
            }),
            _createVNode(_component_Column, {
              field: "c2",
              header: "C.2"
            }),
            _createVNode(_component_Column, {
              field: "drb11",
              header: "DRB1.1"
            }),
            _createVNode(_component_Column, {
              field: "drb12",
              header: "DRB1.2"
            }),
            _createVNode(_component_Column, {
              field: "dqb11",
              header: "DQB1.1"
            }),
            _createVNode(_component_Column, {
              field: "dqb12",
              header: "DQB1.2"
            }),
            _createVNode(_component_Column, {
              field: "dpb11",
              header: "DPB1.1"
            }),
            _createVNode(_component_Column, {
              field: "dpb12",
              header: "DPB1.2"
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_LineMenu, null, {
          default: _withCtx(() => [
            _createVNode(_component_SplitButton, {
              label: "More donors",
              class: "p-mr-2 p-button-raised p-button-rounded",
              icon: "pi pi-plus",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moreDonors())),
              model: _ctx.parsePdf
            }, null, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm",
          value: _ctx.donors,
          expandedRows: _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedRows) = $event)),
          showGridlines: "",
          stripedRows: "",
          autoLayout: "",
          rowClass: (data) => (data.don.emdRequest ? '' : 'no-expander'),
          onRowExpand: _ctx.onRowExpand
        }, {
          expansion: _withCtx((slotProps) => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm",
              value: slotProps.data.req,
              showGridlines: "",
              stripedRows: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "id",
                  header: "Request ID",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  header: "Request Status",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.ReqStatus.byCode(slotProps.data.status)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_Column, {
                  header: "Request Type",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.ReqType.byCode(slotProps.data.reqtype)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_Column, {
                  field: "reserveduntil",
                  header: "Reserved Until",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.reserveduntil)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_Column, {
                  field: "smparrdate",
                  header: "Sample Arrival Date",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.smparrdate)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_Column, {
                  header: "Record update",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.news)
                      ? (_openBlock(), _createBlock(_component_InlineMessage, {
                          key: 0,
                          severity: slotProps.data.news == 'UPD' ? 'warn' : 'info'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(slotProps.data.news), 1)
                          ]),
                          _: 2
                        }, 1032, ["severity"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              expander: true,
              rowWidth: "10px"
            }),
            _createVNode(_component_Column, { header: "GRID/CB_ID" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getGrid(slotProps.data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "don.ion",
              header: "Donor registry ION"
            }),
            _createVNode(_component_Column, {
              field: "don.nationality",
              header: "Nationality"
            }),
            _createVNode(_component_Column, { header: "Match" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getMatch(slotProps.data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "MM locus" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getMMLocus(slotProps.data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DPB1 permissibility" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.MgPermissibility.byCode(slotProps.data.don.mgPermisive)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Age" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getAge(slotProps.data.don.birthdate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "ABORH" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getAboRh(slotProps.data.don.abo, slotProps.data.don.rh)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "CMV" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.Cmv.byCode(slotProps.data.don.cmv)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Gender" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.Gender.byCode(slotProps.data.don.gender)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Status" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.EmdisDonorState.byCode(slotProps.data.don.donemdisstate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_RecRequest, {
                  don: slotProps.data,
                  mode: _ctx.ReqType.NEW
                }, null, 8, ["don", "mode"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Reservation" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_RecRequest, {
                  don: slotProps.data,
                  mode: _ctx.ReqType.RESREQ
                }, null, 8, ["don", "mode"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_SplitButton, {
                  label: "Show Match",
                  class: "p-button-raised p-button-rounded",
                  onClick: ($event: any) => (_ctx.showMatch(slotProps.data)),
                  model: _ctx.getButtonsModel(slotProps.data)
                }, null, 8, ["onClick", "model"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Record update" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.don.news)
                  ? (_openBlock(), _createBlock(_component_InlineMessage, {
                      key: 0,
                      severity: slotProps.data.don.news == 1 ? 'info' : 'warn'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(slotProps.data.don.news == 1 ? "News" : "Update"), 1)
                      ]),
                      _: 2
                    }, 1032, ["severity"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "expandedRows", "rowClass", "onRowExpand"]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ProgressSpinner, {
                strokeWidth: "4",
                style: {"width":"50px","height":"50px"}
              }),
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: "Show Match",
      visible: _ctx.showMatchDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showMatchDialog) = $event)),
      modal: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm",
          value: _ctx.showMatchData(),
          resizableColumns: "",
          showGridlines: "",
          stripedRows: "",
          autoLayout: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "Type" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.dontype)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.DonorType.byCode(slotProps.data.dontype)), 1))
                  : (slotProps.data.type)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(slotProps.data.type), 1))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "A.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mga1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.a1,
                slotProps.data.dnaRequest.a2,
                slotProps.data.hlaRequest.hlaa1
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "A.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mga2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.a2,
                slotProps.data.dnaRequest.a1,
                slotProps.data.hlaRequest.hlaa2
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "B.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgb1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.b1,
                slotProps.data.dnaRequest.b2,
                slotProps.data.hlaRequest.hlab1
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "B.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgb2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.b2,
                slotProps.data.dnaRequest.b1,
                slotProps.data.hlaRequest.hlab2
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "C.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgc1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.c1,
                slotProps.data.dnaRequest.c2,
                slotProps.data.hlaRequest.hlac1
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "C.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgc2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.c2,
                slotProps.data.dnaRequest.c1,
                slotProps.data.hlaRequest.hlac2
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DR.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdr1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.drb11,
                slotProps.data.dnaRequest.drb12,
                slotProps.data.hlaRequest.hladr1
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DR.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdr2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.drb12,
                slotProps.data.dnaRequest.drb11,
                slotProps.data.hlaRequest.hladr2
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DQ.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdq1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.dqb11,
                slotProps.data.dnaRequest.dqb12,
                slotProps.data.hlaRequest.hladq1
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DQ.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdq2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.dqb12,
                slotProps.data.dnaRequest.dqb11,
                slotProps.data.hlaRequest.hladq2
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DPB1.1" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdpb1))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.dpb11,
                slotProps.data.dnaRequest.dpb12,
                ""
              )), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "DPB1.2" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.dnaColor(slotProps.data.mgdpb2))
                }, _toDisplayString(_ctx.getDna(
                slotProps.data.dnaRequest.dpb12,
                slotProps.data.dnaRequest.dpb11,
                ""
              )), 5)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}